import { useState, useEffect } from "react";
import styles from "./styles.module.css";

const SafeImage = ({
  src,
  alt,
  fallback,
  className,
}: {
  src: string;
  alt: string;
  fallback: string;
  className?: string;
}) => {
  const [imgSrc, setImgSrc] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!src) {
      setImgSrc(fallback);
      setLoading(false);
      return;
    }

    setLoading(true);
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImgSrc(src);
      setLoading(false);
    };
    img.onerror = () => {
      setImgSrc(fallback);
      setLoading(false);
    };
  }, [src, fallback]);

  return (
    <div style={{ position: "relative" }}>
      {loading && <div className={styles.skeletonLoader} />}
      {!loading && (
        <img
          src={imgSrc}
          alt={alt}
          className={`${styles.image} ${className}`}
          style={{ objectFit: "cover" }}
        />
      )}
    </div>
  );
};

export default SafeImage;
